import type { IAnyComplexType, Instance, SnapshotIn, SnapshotOut } from "@gadgetinc/mobx-quick-tree";
import { applySnapshot, getSnapshot, onSnapshot } from "@gadgetinc/mobx-quick-tree";

export function persistInLocalStorage<T extends IAnyComplexType>(
  storageKey: string,
  self: Instance<T>,
  transform?: (snapshot: SnapshotOut<T>) => SnapshotIn<T>
) {
  if (window?.localStorage) {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      applySnapshot(self, JSON.parse(stored));
    }

    onSnapshot(self, () => {
      let snapshot = getSnapshot(self);
      if (transform) {
        snapshot = transform(snapshot as any);
      }
      localStorage.setItem(storageKey, JSON.stringify(snapshot));
    });
  }
}
